import React from 'react';
import { SalesChannelHeader } from '@/src/layout/SalesChannelEditorLayout/HomeLayout';
import css from './css.module.less';
//import Warning from '@/src/components/Antd/Modal/WarningModal';
import { headerHeight } from 'src/layout/Components/config';
import { SalesChannelStatus } from '@/src/types/common/SalesChannel';

interface IHeaderConfig {
  title: string | JSX.Element;
  description;
  status: SalesChannelStatus;
  hasModified: boolean;
  onSubmit: () => void;
  onDiscard;
  onGoBack;
  hideMultiLanguage?: boolean;
  hasStyleSelect?: boolean;
  submitLoading?: boolean;
  onContentReverse?: () => void;
  rarePart?: any;
  translationEnabled?: boolean | undefined;
  handleOnTranslate?: (obj: any) => void;
  translationLoading?: boolean | undefined;
}

interface IProps {
  headerStyleProps?: Record<string, unknown>;
  headerProps: IHeaderConfig;
  customHeader?: JSX.Element;
  children?: any;
  rarePart?: any;
}
const Wrapper = (props: IProps) => {
  const { headerStyleProps, customHeader, children, headerProps } = props;
  const {
    title,
    description,
    status,
    hasModified,
    onSubmit,
    onDiscard,
    onGoBack,
    hideMultiLanguage,
    hasStyleSelect,
    submitLoading,
    onContentReverse,
    rarePart,
    translationEnabled,
    handleOnTranslate,
    translationLoading,
  } = headerProps;
  return (
    <div className={css.pageWrapper}>
      {/* <Warning
        visible={draftWarning.visible}
        header='Warning'
        onOk={draftWarning.onOk}
        okText={'Save'}
        cancelText={'Continue editing'}
        onCancel={handleOnDraftWarningClose}>
        You can save this draft version. However, you will not be able to
        publish this version before all the errors are fixed.
      </Warning>
      <Warning
        visible={scheduledWarning.visible}
        header='Unable to save changes'
        cancelText={'Continue editing'}
        onCancel={handleOnScheduledWarningClose}>
        No errors are allowed in a live version. Please fix all errors before
        save.
      </Warning> */}
      <div
        className={css.header}
        // headerProps
        style={{
          top: headerHeight,
          ...(headerStyleProps || {}),
        }}>
        {customHeader || (
          <SalesChannelHeader
            title={title}
            description={description}
            status={status}
            hasModified={hasModified}
            submit={onSubmit}
            onDiscard={onDiscard}
            onGoBack={onGoBack}
            hideMultiLanguage={hideMultiLanguage}
            hasStyleSelect={hasStyleSelect}
            submitLoading={submitLoading}
            onContentReverse={onContentReverse}
            rarePart={rarePart}
            translationEnabled={translationEnabled}
            onChangeTranslation={handleOnTranslate}
            translationLoading={translationLoading}
          />
        )}
      </div>
      {children}
    </div>
  );
};
export default Wrapper;
